(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coffee-lineup"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-lineup-stack]').forEach(stack => {
    const layout = stack.closest('.coffee-lineup__layout');
    const detailsPanels = layout ? Array.from(layout.querySelectorAll('[data-details-panel]')) : [];

    /* Logical stack order lives in this array, not in DOM order — moving
       a card to front only ever updates --stack-index/is-front on the
       existing elements, never reparents them. Reparenting (an earlier
       version of this used stack.prepend) resets the CSS transition's
       starting point on the moved node, so it jumped to its new spot
       instantly while every other card (which never moved in the DOM,
       just got a new --stack-index) animated normally. */
    let order = Array.from(stack.querySelectorAll('[data-stack-item]'));

    function updateDetails() {
      const front = order[0];
      if (!front) return;
      const frontIndex = front.dataset.productIndex;
      detailsPanels.forEach(panel => {
        panel.hidden = panel.dataset.productIndex !== frontIndex;
      });
    }

    function applyOrder() {
      order.forEach((item, index) => {
        item.style.setProperty('--stack-index', index);
        item.classList.toggle('is-front', index === 0);
      });
      updateDetails();
    }

    applyOrder();

    order.forEach(item => {
      item.addEventListener('click', (e) => {
        if (item.classList.contains('is-front')) return;
        e.preventDefault();
        order = [item, ...order.filter((other) => other !== item)];
        applyOrder();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drink-guide"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-drink-tabs]').forEach((root) => {
    const tabs = root.querySelectorAll('[role="tab"]');
    const panels = root.querySelectorAll('[role="tabpanel"]');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.forEach((t) => {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        panels.forEach((p) => p.classList.remove('is-active'));

        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        const panel = root.querySelector(`#${tab.dataset.tabTarget}`);
        if (panel) panel.classList.add('is-active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["equipment-guide"] && !Shopify.designMode) return;
  try {
    
  function equipmentGuideFormatPrice(value) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0,
    }).format(value);
  }

  document.querySelectorAll('[data-equipment-guide]').forEach(root => {
    root.querySelectorAll('[data-price]').forEach(el => {
      const value = parseFloat(el.dataset.price);
      if (!isNaN(value)) el.textContent = equipmentGuideFormatPrice(value);
    });

    const tabs = root.querySelectorAll('[data-tab]');
    const panels = root.querySelectorAll('[data-panel]');

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        tabs.forEach(t => {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        panels.forEach(p => p.classList.remove('is-active'));

        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        const panel = root.querySelector(`[data-panel="${tab.dataset.tab}"]`);
        if (panel) panel.classList.add('is-active');
      });
    });

    function recalcTier(tier) {
      const panelName = tier === 'solid' ? 'solid-start' : 'end-game';
      const panel = root.querySelector(`[data-panel="${panelName}"]`);
      if (!panel) return;
      let sum = 0;
      /* Only visible rows count — in automatic mode the espresso grinder row is
         hidden and its cost has to drop out of the package total. */
      panel.querySelectorAll('[data-equipment-item]').forEach(item => {
        if (item.hasAttribute('hidden')) return;
        const el = item.querySelector('.equipment-guide__summary-price');
        if (el) sum += parseFloat(el.dataset.price) || 0;
      });
      const formatted = equipmentGuideFormatPrice(sum);
      panel.querySelectorAll('[data-panel-total]').forEach(el => {
        el.textContent = formatted;
      });
      root.querySelectorAll(`[data-summary-total="${tier}"]`).forEach(el => {
        el.textContent = formatted;
      });
    }

    root.querySelectorAll('[data-toggle-group]').forEach(group => {
      const item = group.closest('[data-equipment-item]');
      if (!item) return;
      const nameEl = item.querySelector('[data-item-name]');
      const tagEl = item.querySelector('[data-item-tag]');
      const priceEl = item.querySelector('.equipment-guide__summary-price');
      const variants = item.querySelectorAll('[data-variant-content]');
      const options = group.querySelectorAll('[data-toggle-option]');
      const tier = item.dataset.tier;

      options.forEach(option => {
        option.addEventListener('click', () => {
          options.forEach(o => o.classList.remove('is-active'));
          option.classList.add('is-active');

          if (nameEl) nameEl.textContent = option.dataset.name;
          if (tagEl) tagEl.textContent = option.textContent.trim();
          const price = parseFloat(option.dataset.value) || 0;
          if (priceEl) {
            priceEl.dataset.price = price;
            priceEl.textContent = equipmentGuideFormatPrice(price);
          }
          variants.forEach(v => {
            v.classList.toggle('is-active', v.dataset.variant === option.dataset.variant);
          });
          recalcTier(tier);
        });
      });
    });

    /* Manual / Automatic espresso switch.
       Drives the tagged espresso rows by clicking their (hidden) variant pills,
       so there is exactly one code path for swapping an option. Both tiers are
       switched together — the choice is "how do you want to make espresso",
       not a per-package option. */
    const modeOptions = root.querySelectorAll('[data-mode-option]');

    function applyMode(mode) {
      modeOptions.forEach(option => {
        const isActive = option.dataset.mode === mode;
        option.classList.toggle('is-active', isActive);
        option.setAttribute('aria-pressed', String(isActive));
      });

      root.querySelectorAll('[data-mode-role="espresso"]').forEach(item => {
        const pill = item.querySelector(`[data-toggle-option][data-variant="${mode}"]`);
        if (pill && !pill.classList.contains('is-active')) pill.click();
      });

      root.querySelectorAll('[data-mode-role="espresso-grinder"]').forEach(item => {
        item.hidden = mode === 'automatic';
      });
      root.querySelectorAll('[data-builtin-item]').forEach(item => {
        item.hidden = mode !== 'automatic';
      });

      recalcTier('solid');
      recalcTier('end');
    }

    modeOptions.forEach(option => {
      option.addEventListener('click', () => applyMode(option.dataset.mode));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-drop"] && !Shopify.designMode) return;
  try {
    
  /* Scroll-linked "story" reveal. The section's outer element is taller
     than the viewport (--fd-scroll-length) purely to give the pinned inner
     frame (position: sticky) scroll distance to animate against — nothing
     here actually scrolls in the normal sense. Progress through that
     distance (0 to 1) is split into phases, each driving one part of the
     reveal via direct style writes (cheaper than toggling classes for a
     value that changes every frame, and avoids fighting CSS
     custom-property/calc unit-mixing for a JS-computed measurement like
     the word-mark's shift below). The scroll length itself (400vh) plus
     dead zones between phases are what give the whole thing room to
     breathe instead of feeling rushed. */
  function initFeaturedDrop(section) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const wordmark = section.querySelector('[data-fd-wordmark]');
    const wordDrop = section.querySelector('[data-fd-word-drop]');
    const wordFeatured = section.querySelector('[data-fd-word-featured]');
    const month = section.querySelector('[data-fd-month]');
    const paragraph = section.querySelector('[data-fd-paragraph]');
    const bag = section.querySelector('[data-fd-bag]');
    const info = section.querySelector('[data-fd-info]');
    const originLine = section.querySelector('[data-fd-origin-line]');

    if (!wordmark || !month) return;

    /* How far the word mark has to travel so it's centered on the month
       label — measured from actual layout (not guessed in vh) so it lines
       up regardless of viewport size or font metrics. The words stay full
       size (no shrink), so most of this now-huge block ends up scrolled
       off past the top of the frame (clipped by the pin's overflow:
       hidden) — that's fine, it's what frees up the space the bag/info
       need below. What's left visible settles centered behind the month
       label, faded down (see opacity below) so it reads as tucked behind
       it rather than competing with it. Re-measured on resize since both
       elements' positions can shift. */
    let wordShift = 0;
    function measure() {
      const priorTransform = wordmark.style.transform;
      wordmark.style.transform = 'none';
      const wordRect = wordmark.getBoundingClientRect();
      const monthRect = month.getBoundingClientRect();
      const wordCenterY = wordRect.top + wordRect.height / 2;
      const monthCenterY = monthRect.top + monthRect.height / 2;
      wordShift = monthCenterY - wordCenterY;
      wordmark.style.transform = priorTransform;
    }

    function update() {
      const scrollable = section.offsetHeight - window.innerHeight;
      let progress = 0;
      if (scrollable > 0) {
        progress = -section.getBoundingClientRect().top / scrollable;
      }
      progress = Math.min(1, Math.max(0, progress));

      /* Three keyframes (word/paragraph in, product in, origin line in),
         handed off back-to-back with no idle gap between them — instead
         of pausing between motions, each motion itself is stretched out
         (long durations relative to the total 0-1 range, plus a longer
         --fd-scroll-length above) so the whole thing simply reads as
         slower, not as moving-then-stopping-then-moving:

           0.00–0.05  dead zone (scroll "resistance" before anything moves)
           0.05–0.32  word mark rises (slow)
           0.27–0.52  paragraph fades in (slight overlap with the word
                      mark's tail, same as it settles)
           0.52–0.74  paragraph fades/rises back out — starts exactly where
                      its own fade-in ended, no dwell
           0.74–0.94  keyframe 2: bag + info slide in — starts exactly
                      where the paragraph's exit ended
           0.94–1.00  keyframe 3: origin line fades in */
      const pWord = Math.min(1, Math.max(0, (progress - 0.05) / 0.27));
      const pText = Math.min(1, Math.max(0, (progress - 0.27) / 0.25));
      const pParaExit = Math.min(1, Math.max(0, (progress - 0.52) / 0.22));
      const pProduct = Math.min(1, Math.max(0, (progress - 0.74) / 0.2));
      const pC = Math.min(1, Math.max(0, (progress - 0.94) / 0.06));

      wordmark.style.transform = 'translateY(' + (pWord * wordShift) + 'px)';
      if (wordDrop) wordDrop.style.opacity = 0.5 - pWord * 0.38;
      if (wordFeatured) wordFeatured.style.opacity = 1 - pWord * 0.75;

      /* Paragraph fades/slides in same as before, dwells at full opacity,
         then fully fades/rises out via pParaExit alone — done well before
         pProduct (below) starts, so there's no window where both are
         visible at once. */
      if (paragraph) {
        paragraph.style.opacity = pText * (1 - pParaExit);
        paragraph.style.transform =
          'translateX(-50%) translateY(calc(' + ((1 - pText) * 2) + 'rem - ' + (pParaExit * 60) + 'vh))';
      }

      if (bag) {
        bag.style.opacity = pProduct;
        bag.style.transform = 'translateX(' + ((1 - pProduct) * -4) + 'rem)';
      }
      if (info) {
        info.style.opacity = pProduct;
        info.style.transform = 'translateX(' + ((1 - pProduct) * 4) + 'rem)';
      }

      if (originLine) {
        originLine.style.opacity = pC;
        originLine.style.transform = 'translateX(-50%) translateY(' + ((1 - pC) * 1.5) + 'rem)';
      }
    }

    measure();
    update();

    let ticking = false;
    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        update();
        ticking = false;
      });
    }, { passive: true });

    window.addEventListener('resize', () => {
      measure();
      update();
    });
  }

  document.querySelectorAll('[data-featured-drop]').forEach(initFeaturedDrop);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    var body = document.body;

    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      body.style.overflow = 'hidden';
      document.querySelectorAll('[data-drawer-open]').forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'true');
      });
    }

    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      body.style.overflow = '';
      document.querySelectorAll('[data-drawer-open]').forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
    }

    /* Cart contents and the hamburger's item-count badge both come from the
       server so the drawer's markup and the money formatting stay in one
       place (Liquid), instead of re-implementing cart math in JS. */
    function refresh() {
      var url = window.location.pathname + window.location.search;
      url += (url.indexOf('?') === -1 ? '?' : '&') + 'sections=header';

      return fetch(url)
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var html = data.header;
          if (!html) return;
          var temp = document.createElement('div');
          temp.innerHTML = html;

          var freshBody = temp.querySelector('[data-drawer-cart-body]');
          var liveBody = document.querySelector('[data-drawer-cart-body]');
          if (freshBody && liveBody) liveBody.innerHTML = freshBody.innerHTML;

          var freshHamburger = temp.querySelector('.nostalgica-header__hamburger');
          var liveHamburger = document.querySelector('.nostalgica-header__hamburger');
          if (freshHamburger && liveHamburger) liveHamburger.innerHTML = freshHamburger.innerHTML;
        });
    }

    function changeQuantity(line, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(refresh)
        .catch(function () {
          window.showToast('Could not update cart', 'error');
        });
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-open]')) {
        e.preventDefault();
        refresh().then(open);
        return;
      }
      if (e.target.closest('[data-drawer-close]')) {
        e.preventDefault();
        close();
        return;
      }
      var qtyBtn = e.target.closest('[data-quantity-adjust]');
      if (qtyBtn) {
        var line = parseInt(qtyBtn.dataset.line, 10);
        var valueEl = qtyBtn.parentElement.querySelector('.cart-drawer__qty-value');
        var current = parseInt(valueEl.textContent, 10) || 0;
        var next = qtyBtn.dataset.quantityAdjust === 'plus' ? current + 1 : current - 1;
        if (next < 0) next = 0;
        changeQuantity(line, next);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    /* Product forms dispatch this after a successful add to cart. */
    document.addEventListener('cart:refresh', function () {
      refresh().then(open);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-bar"] && !Shopify.designMode) return;
  try {
    
  function initStoryToggle(story) {
    const toggle = story.nextElementSibling;
    if (!toggle) return;
    if (story.hidden) {
      toggle.hidden = true;
      return;
    }
    story.classList.remove('is-expanded');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.textContent = 'Read more';
    requestAnimationFrame(() => {
      toggle.hidden = story.scrollHeight <= story.clientHeight + 4;
    });
  }

  document.querySelectorAll('[data-story]').forEach((story) => {
    initStoryToggle(story);
    const toggle = story.nextElementSibling;
    if (!toggle) return;
    toggle.addEventListener('click', () => {
      const expanded = story.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', String(expanded));
      toggle.textContent = expanded ? 'Show less' : 'Read more';
    });
  });

  // Live-updates when a matching variant option (e.g. "Select Your Blend")
  // changes elsewhere on the page — see subscription-product.liquid, which
  // renders the actual <select> this listens for.
  document.querySelectorAll('[data-blend-info-json]').forEach((script) => {
    let data;
    try {
      data = JSON.parse(script.textContent);
    } catch (e) {
      return;
    }
    const optionName = script.dataset.blendOptionName;
    const box = script.closest('.product-info');
    if (!box) return;

    const titleEl = box.querySelector('[data-product-info-title]');
    const descriptionEl = box.querySelector('[data-product-info-description]');
    const descriptionWrapper = box.querySelector('.product-info__column--description [data-story]');
    const storyWrapper = box.querySelector('.product-info__column--story [data-story]');
    const storyEl = box.querySelector('[data-product-info-story]');

    function setDetail(name, value) {
      const row = box.querySelector('[data-detail-row="' + name + '"]');
      const dd = box.querySelector('[data-detail="' + name + '"]');
      if (!row || !dd) return;
      if (value) {
        dd.textContent = value;
        row.hidden = false;
      } else {
        row.hidden = true;
      }
    }

    function applyInfo(info) {
      if (!info) return;
      if (titleEl) titleEl.textContent = info.title;
      if (descriptionEl) descriptionEl.textContent = info.description || '';
      if (descriptionWrapper) {
        descriptionWrapper.hidden = !info.description;
        initStoryToggle(descriptionWrapper);
      }
      if (storyEl) storyEl.innerHTML = info.story || '';
      if (storyWrapper) {
        storyWrapper.hidden = !info.story;
        initStoryToggle(storyWrapper);
      }
      setDetail('origin', info.origin);
      setDetail('process', info.process);
      setDetail('varietal', info.varietal);
      setDetail('elevation', info.elevation);
      setDetail('agtron', info.agtron);
    }

    document.addEventListener('change', (e) => {
      const input = e.target;
      if (!input.matches || !input.matches('[data-option-input]')) return;
      const wrapper = input.closest('[data-option-name]');
      if (!wrapper || wrapper.dataset.optionName !== optionName) return;
      applyInfo(data[input.value]);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('[data-product-recs]');
    if (!section) return;
    const productId = section.dataset.productId;
    const sectionId = section.dataset.sectionId;
    const url = `/recommendations/products?section_id=${sectionId}&product_id=${productId}&limit=3`;
    fetch(url)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newSection = doc.querySelector('.product-recs');
        if (newSection) section.replaceWith(newSection);
      })
      .catch(err => console.error('Recommendations fetch failed:', err));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductForm {
  constructor(section) {
    this.section = section;
    const jsonEl = section.querySelector('[data-product-json]');
    this.product = JSON.parse(jsonEl.textContent);
    // Variant id → wholesale price in cents. Empty for retail customers.
    const wholesaleEl = section.querySelector('[data-wholesale-json]');
    try {
      this.wholesalePrices = wholesaleEl ? JSON.parse(wholesaleEl.textContent) : {};
    } catch (e) {
      this.wholesalePrices = {};
    }
    this.form = section.querySelector('[data-product-form]');
    this.priceEl = section.querySelector('[data-price]');
    this.variantIdInput = section.querySelector('[data-variant-id]');
    this.optionInputs = section.querySelectorAll('[data-option-input]');
    this.qtyInput = section.querySelector('[data-quantity-input]');
    this.qtyButtons = section.querySelectorAll('[data-quantity-adjust]');
    this.atcButton = section.querySelector('[data-atc]');
    this.init();
  }

  init() {
    this.optionInputs.forEach(input => {
      input.addEventListener('change', () => this.onOptionChange());
    });
    this.qtyButtons.forEach(btn => {
      btn.addEventListener('click', () => this.onQuantityAdjust(btn.dataset.quantityAdjust));
    });
    this.qtyInput.addEventListener('input', () => this.updatePrice());
    this.form.addEventListener('submit', (e) => this.onSubmit(e));
  }

  getCurrentVariant() {
    const options = [];
    this.section.querySelectorAll('[data-option-input]').forEach(input => {
      const position = parseInt(input.dataset.optionPosition, 10) - 1;
      if (input.type === 'radio') {
        if (input.checked) options[position] = input.value;
      } else if (input.tagName === 'SELECT') {
        options[position] = input.value;
      }
    });
    return this.product.variants.find(v => {
      return options.every((val, idx) => v.options[idx] === val);
    });
  }

  // Wholesale price for this variant if the customer has one, otherwise retail.
  unitPrice(variant) {
    const wholesale = this.wholesalePrices[variant.id];
    return typeof wholesale === 'number' ? wholesale : variant.price;
  }

  updatePrice() {
    const variant = this.getCurrentVariant();
    if (!variant) return;
    const qty = parseInt(this.qtyInput.value, 10) || 1;
    this.priceEl.textContent = this.formatMoney(this.unitPrice(variant) * qty);
  }

  onOptionChange() {
    const variant = this.getCurrentVariant();
    if (!variant) return;
    this.variantIdInput.value = variant.id;
    const url = new URL(window.location);
    url.searchParams.set('variant', variant.id);
    history.replaceState({}, '', url);
    this.updatePrice();
  }

  onQuantityAdjust(direction) {
    const current = parseInt(this.qtyInput.value, 10) || 1;
    if (direction === 'plus') {
      this.qtyInput.value = current + 1;
    } else if (direction === 'minus' && current > 1) {
      this.qtyInput.value = current - 1;
    }
    this.updatePrice();
  }

  async onSubmit(e) {
    e.preventDefault();
    const formData = new FormData(this.form);
    this.atcButton.disabled = true;
    try {
      const response = await fetch(this.form.action, {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      });
      if (response.ok) {
        window.showToast('Added to cart');
      } else {
        const data = await response.json();
        window.showToast(data.description || 'Could not add to cart', 'error');
      }
    } catch (err) {
      window.showToast('Something went wrong', 'error');
    } finally {
      this.atcButton.disabled = false;
    }
  }

  formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
}

  document.querySelectorAll('[data-product-section]').forEach(section => {
    new ProductForm(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["signature-drinks"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function fmt(n) {
      var r = n >= 10 ? Math.round(n) : Math.round(n * 10) / 10;
      return r.toLocaleString('en-US');
    }
    function scale(text, f, whole) {
      if (f === 1) return text;
      /* Counted things (strips, lemons, jugs, pinches) round to the nearest half, never below ½. */
      var counted = !whole && !/\d\s*(g|fl oz)\b/.test(text);
      if (counted) return text.replace(/\d+(?:\.\d+)?/g, function (m) {
        var n = Math.max(0.5, Math.round(parseFloat(m) * f * 2) / 2);
        return n.toLocaleString('en-US');
      });
      return text.replace(/\d{1,3}(?:,\d{3})+(?:\.\d+)?|\d+(?:\.\d+)?/g, function (m) {
        var n = parseFloat(m.replace(/,/g, '')) * f;
        return whole ? Math.max(1, Math.round(n)).toLocaleString('en-US') : fmt(n);
      });
    }
    function applyMult(input) {
      var base = input.closest('[data-sig-base]');
      var f = parseFloat(input.value);
      if (!base || !(f > 0)) return;
      base.querySelectorAll('[data-sig-scale]').forEach(function (el) {
        el.textContent = scale(el.getAttribute('data-base-text'), f, el.hasAttribute('data-sig-int'));
      });
    }
    function esc(s) {
      return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
    }

    /* Tabs — same behavior as the guide's recipe groups. */
    function showTab(tab) {
      var set = tab.closest('[data-sig-tabs]');
      set.querySelectorAll('[role="tab"]').forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      set.querySelectorAll('[role="tabpanel"]').forEach(function (p) {
        p.classList.toggle('is-active', p.id === tab.getAttribute('data-sig-tab'));
      });
    }
    function reveal(id) {
      var tab = document.querySelector('[data-sig-tab="' + id + '"]');
      if (tab) showTab(tab);
      var el = document.getElementById(id);
      if (el) (tab ? tab.closest('[data-sig-tabs]') : el).scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    var cloneCount = 0;
    function init() {
      var cards = Array.prototype.slice.call(document.querySelectorAll('.sig-card'));
      var menu = document.querySelector('[data-sig-menu]');
      if (menu && cards.length) {
        var groups = [], byGroup = {}, lastSeason = null;
        cards.forEach(function (c) {
          var key = (c.getAttribute('data-season') || '') + '|' + (c.getAttribute('data-group') || '');
          if (!byGroup[key]) { byGroup[key] = []; groups.push(key); }
          byGroup[key].push(c);
        });
        menu.innerHTML = groups.map(function (key) {
          var season = key.split('|')[0], g = key.split('|')[1], head = '';
          if (season !== lastSeason) { head = season ? '<p class="drink-guide__section-eyebrow sig-menu__season">' + esc(season) + '</p>' : ''; lastSeason = season; }
          return head + '<div class="sig-menu__group"><p class="drink-guide__info-title sig-menu__group-name">' + esc(g) + '</p>' +
            '<div class="sig-menu__chips">' + byGroup[key].map(function (c) {
              return '<a class="sig-menu__chip" href="#' + c.id + '" data-sig-jump="' + c.id + '" data-temp="' + esc(c.getAttribute('data-temp')) + '">' + esc(c.getAttribute('data-name')) + '</a>';
            }).join('') + '</div></div>';
        }).join('');
        var label = document.querySelector('[data-sig-toggle-label]');
        if (label) label.textContent = 'Browse all ' + cards.length + ' drinks';
        var wrap = document.querySelector('[data-sig-menu-wrap]');
        if (wrap) wrap.hidden = false;
        var drawer = document.querySelector('[data-sig-drawer]');
        if (drawer && window.matchMedia('(max-width: 767px)').matches) drawer.open = false;
      }

      document.querySelectorAll('[data-sig-used]').forEach(function (box) {
        var id = box.getAttribute('data-sig-used');
        var users = cards.filter(function (c) { return (',' + (c.getAttribute('data-bases') || '')).indexOf(',' + id + ',') !== -1; });
        if (!users.length) return;
        box.innerHTML = '<span>Used in</span>' + users.map(function (c) {
          return '<a href="#' + c.id + '" data-sig-jump="' + c.id + '">' + esc(c.getAttribute('data-name')) + '</a>';
        }).join('');
        box.hidden = false;
      });

      if (location.hash && document.querySelector('[data-sig-tab="' + location.hash.slice(1) + '"]')) reveal(location.hash.slice(1));
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

    /* Prep first — copy the base recipe into the drink the first time its panel opens. */
    document.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d.matches || !d.matches('details[data-base-ref]') || !d.open || d.hasAttribute('data-filled')) return;
      var src = document.getElementById(d.getAttribute('data-base-ref'));
      var recipe = src && src.querySelector('[data-sig-base]');
      if (!recipe) return;
      var copy = recipe.cloneNode(true);
      cloneCount += 1;
      copy.querySelectorAll('[id]').forEach(function (el) { el.id = el.id + '-c' + cloneCount; });
      copy.querySelectorAll('label[for]').forEach(function (el) { el.setAttribute('for', el.getAttribute('for') + '-c' + cloneCount); });
      copy.querySelectorAll('input[type="checkbox"]').forEach(function (c) { c.checked = false; });
      copy.querySelectorAll('.sig-step').forEach(function (s) { s.setAttribute('aria-pressed', 'false'); });
      var slot = d.querySelector('[data-base-slot]');
      slot.innerHTML = '';
      slot.appendChild(copy);
      var m = copy.querySelector('[data-sig-mult]');
      if (m) { m.value = 1; applyMult(m); }
      d.setAttribute('data-filled', '');
    }, true);

    document.addEventListener('input', function (e) {
      if (e.target.matches && e.target.matches('[data-sig-mult]')) applyMult(e.target);
    });

    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.classList && e.target.classList.contains('sig-step')) {
        e.preventDefault();
        e.target.click();
      }
    });

    document.addEventListener('click', function (e) {
      var root = e.target.closest('[data-sig]');
      if (!root) return;

      var jump = e.target.closest('[data-sig-jump]');
      if (jump) {
        e.preventDefault();
        reveal(jump.getAttribute('data-sig-jump'));
        history.replaceState(null, '', '#' + jump.getAttribute('data-sig-jump'));
        return;
      }

      var tab = e.target.closest('[data-sig-tab]');
      if (tab) { showTab(tab); return; }

      var step = e.target.closest('.sig-step');
      if (step) {
        step.setAttribute('aria-pressed', step.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        return;
      }

      var stepBtn = e.target.closest('[data-sig-step]');
      if (stepBtn) {
        /* Quarter steps at or below 1× (1 → ¾ → ½ → ¼, about 5 drinks), half steps above. */
        var input = stepBtn.closest('[data-sig-base]').querySelector('[data-sig-mult]');
        var cur = parseFloat(input.value) || 1;
        var up = parseFloat(stepBtn.getAttribute('data-sig-step')) > 0;
        var next;
        if (up) next = cur < 1 ? Math.floor(cur * 4 + 1e-9) / 4 + 0.25 : Math.floor(cur * 2 + 1e-9) / 2 + 0.5;
        else next = cur <= 1 ? Math.ceil(cur * 4 - 1e-9) / 4 - 0.25 : Math.ceil(cur * 2 - 1e-9) / 2 - 0.5;
        input.value = Math.max(0.25, Math.min(20, next));
        applyMult(input);
        return;
      }

      var filterBtn = e.target.closest('[data-sig-filter]');
      if (filterBtn) {
        var want = filterBtn.getAttribute('data-sig-filter');
        root.querySelectorAll('[data-sig-filter]').forEach(function (b) {
          var on = b === filterBtn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        function match(el) { var t = el.getAttribute('data-temp'); return want === 'all' || t === want || t === 'both'; }
        document.querySelectorAll('.sig-menu__chip, [data-sig-tab], .sig-card').forEach(function (el) { el.hidden = !match(el); });
        document.querySelectorAll('[data-sig-tabs]').forEach(function (set) {
          var visible = Array.prototype.filter.call(set.querySelectorAll('[data-sig-tab]'), function (t) { return !t.hidden; });
          var head = set.previousElementSibling;
          set.hidden = !visible.length;
          if (head && head.classList.contains('sig-group')) head.hidden = !visible.length;
          var active = set.querySelector('[data-sig-tab].is-active');
          if (visible.length && (!active || active.hidden)) showTab(visible[0]);
          set.querySelectorAll('[role="tabpanel"]').forEach(function (p) { p.hidden = false; });
        });
        return;
      }

      var reset = e.target.closest('[data-sig-reset]');
      if (reset) {
        var card = reset.closest('[data-sig-card]');
        card.querySelectorAll('input[type="checkbox"]').forEach(function (c) { c.checked = false; });
        card.querySelectorAll('.sig-step').forEach(function (s) { s.setAttribute('aria-pressed', 'false'); });
        card.querySelectorAll('[data-sig-mult]').forEach(function (m) { m.value = 1; applyMult(m); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription-product"]) return;
  try {
    
  class SubscriptionProductForm {
    constructor(section) {
      this.section = section;
      const jsonEl = section.querySelector('[data-product-json]');
      this.product = JSON.parse(jsonEl.textContent);
      this.form = section.querySelector('[data-product-form]');
      this.priceEl = section.querySelector('[data-price]');
      this.variantIdInput = section.querySelector('[data-variant-id]');
      this.optionInputs = section.querySelectorAll('[data-option-input]');
      this.qtyInput = section.querySelector('[data-quantity-input]');
      this.atcButton = section.querySelector('[data-atc]');
      this.init();
    }

    init() {
      this.optionInputs.forEach(input => {
        input.addEventListener('change', () => this.onOptionChange());
      });
      this.form.addEventListener('submit', (e) => this.onSubmit(e));
    }

    getCurrentVariant() {
      const options = [];
      this.section.querySelectorAll('[data-option-input]').forEach(input => {
        const position = parseInt(input.dataset.optionPosition, 10) - 1;
        if (input.type === 'radio') {
          if (input.checked) options[position] = input.value;
        } else if (input.tagName === 'SELECT') {
          options[position] = input.value;
        }
      });
      return this.product.variants.find(v => {
        return options.every((val, idx) => v.options[idx] === val);
      });
    }

    updatePrice() {
      const variant = this.getCurrentVariant();
      if (!variant) return;
      const qty = parseInt(this.qtyInput.value, 10) || 1;
      this.priceEl.textContent = this.formatMoney(variant.price * qty);
    }

    onOptionChange() {
      const variant = this.getCurrentVariant();
      if (!variant) return;
      this.variantIdInput.value = variant.id;
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
      this.updatePrice();
    }

    async onSubmit(e) {
      e.preventDefault();
      const formData = new FormData(this.form);
      this.atcButton.disabled = true;
      try {
        const response = await fetch(this.form.action, {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        });
        if (response.ok) {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } else {
          const data = await response.json();
          window.showToast(data.description || 'Could not add to cart', 'error');
        }
      } catch (err) {
        window.showToast('Something went wrong', 'error');
      } finally {
        this.atcButton.disabled = false;
      }
    }

    formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  document.querySelectorAll('[data-subscription-section]').forEach(section => {
    new SubscriptionProductForm(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-inquiry"]) return;
  try {
    
  document.querySelectorAll('[data-inquiry-card]').forEach(card => {
    const form = card.querySelector('[data-inquiry-form]');
    const steps = card.querySelectorAll('[data-step]');
    const markers = card.querySelectorAll('[data-step-marker]');
    const subtitle = card.querySelector('[data-step-subtitle]');
    const nextButtons = card.querySelectorAll('[data-step-next]');
    const backButtons = card.querySelectorAll('[data-step-back]');
    const progress = card.querySelector('[data-progress]');

    function showStep(stepNumber) {
      let subtitleText = '';
      steps.forEach(step => {
        const isActive = parseInt(step.dataset.step, 10) === stepNumber;
        step.classList.toggle('is-active', isActive);
        if (isActive) subtitleText = step.dataset.stepSubtitleText || '';
      });
      markers.forEach(marker => {
        const markerStep = parseInt(marker.dataset.stepMarker, 10);
        marker.classList.remove('is-active', 'is-complete');
        if (markerStep === stepNumber) marker.classList.add('is-active');
        else if (markerStep < stepNumber) marker.classList.add('is-complete');
      });
      if (subtitle) subtitle.textContent = subtitleText;
      progress.setAttribute('aria-valuenow', stepNumber);
      card.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function validateStep(stepNumber) {
      const step = card.querySelector(`[data-step="${stepNumber}"]`);
      const requiredFields = step.querySelectorAll('[required]');
      let isValid = true;
      requiredFields.forEach(field => {
        if (!field.value.trim()) {
          isValid = false;
          field.style.borderColor = 'var(--brand-brick)';
          setTimeout(() => field.style.borderColor = '', 2000);
        }
      });
      return isValid;
    }

    nextButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        const currentStepNum = parseInt(btn.dataset.stepNext, 10);
        if (!validateStep(currentStepNum)) return;
        showStep(currentStepNum + 1);
      });
    });

    backButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        const currentStepNum = parseInt(btn.dataset.stepBack, 10);
        showStep(currentStepNum - 1);
      });
    });

    if (!form) return;
    // Native Shopify submit (customer form). Just guard against double taps.
    form.addEventListener('submit', () => {
      const btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-orders"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-reorder-btn]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const container = btn.closest('[data-order-item]');
      let items = [];
      try {
        items = JSON.parse(container.dataset.orderItems);
      } catch (e) {
        items = [];
      }

      if (!items.length) {
        if (window.showToast) window.showToast('Nothing in this order is available to reorder', 'error');
        return;
      }

      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then((res) => {
          if (!res.ok) throw new Error('reorder failed');
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        })
        .catch(() => {
          if (window.showToast) window.showToast('Could not reorder', 'error');
        })
        .finally(() => {
          btn.disabled = false;
        });
    });
  });

  /* Details accordion — same pattern as the tools list's preview toggle:
     opening one closes any other that's open. */
  document.querySelectorAll('[data-details-toggle]').forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const panel = toggle.nextElementSibling;
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';

      document.querySelectorAll('[data-details-toggle][aria-expanded="true"]').forEach((other) => {
        if (other !== toggle) {
          other.setAttribute('aria-expanded', 'false');
          other.nextElementSibling.hidden = true;
        }
      });

      toggle.setAttribute('aria-expanded', String(!isOpen));
      panel.hidden = isOpen;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-portal-login"]) return;
  try {
    
  document.querySelectorAll('[data-wholesale-login]').forEach((strip) => {
    if (!strip.id) return;
    function triggerHighlight() {
      strip.classList.remove('is-highlighted');
      void strip.offsetWidth;
      strip.classList.add('is-highlighted');
    }
    document.querySelectorAll(`a[href="#${strip.id}"]`).forEach((link) => {
      link.addEventListener('click', triggerHighlight);
    });
    if (window.location.hash === `#${strip.id}`) triggerHighlight();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-tools-list"] && !Shopify.designMode) return;
  try {
    
  /* Accordion: opening one preview closes any other that's open. */
  document.querySelectorAll('[data-preview-toggle]').forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const panel = toggle.nextElementSibling;
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';

      document.querySelectorAll('[data-preview-toggle][aria-expanded="true"]').forEach((other) => {
        if (other !== toggle) {
          other.setAttribute('aria-expanded', 'false');
          other.nextElementSibling.hidden = true;
        }
      });

      toggle.setAttribute('aria-expanded', String(!isOpen));
      panel.hidden = isOpen;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
